module.exports = __webpack_public_path__ + "static/scale-model-of-the-buckhorn-saloon-&-museum-in-san-antonio-texas-631b3f0c39db45045a43e6a77de53a40.png";